import React from 'react'
import PropTypes from 'prop-types'
import { Table as AntTable } from 'antd'
import TableContainer from '../../shared/Table'

/**
 *
  Definition from back
 */

const columns = [
  {
    title: 'Estado',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: 'Fecha',
    dataIndex: 'date_purchased',
    key: 'date_purchased'
  },
  {
    title: 'Tipo',
    dataIndex: 'order_type',
    key: 'order_type'
  },
  {
    title: 'Estado',
    dataIndex: 'order_status',
    key: 'order_status'
  }
]

class LastPurchasesTable extends React.PureComponent {
  static displayName = 'LastPurchasesTable'

  render () {
    const { data, loading, ...props } = this.props
    return (
      <TableContainer {...props}>
        {
          ({ onRow, onPaginationChange }) => (
            <AntTable
              loading={loading}
              className='bo-table'
              size='small'
              pagination={null}
              columns={columns}
              dataSource={data}
              onChange={onPaginationChange}
              onRow={(record, rowIndex) => onRow(record, rowIndex)}
            />
          )
        }
      </TableContainer>
    )
  }
}

LastPurchasesTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func
}

export default LastPurchasesTable
